import {
  GET_INTERNSHIP_SERVICES,
  GET_INTERNSHIP_SERVICES_FAIL,
  GET_INTERNSHIP_SERVICES_SUCCESS,
  ADD_NEW_INTERNSHIP_SERVICE,
  ADD_INTERNSHIP_SERVICE_SUCCESS,
  ADD_INTERNSHIP_SERVICE_FAIL,
  UPDATE_INTERNSHIP_SERVICE,
  UPDATE_INTERNSHIP_SERVICE_SUCCESS,
  UPDATE_INTERNSHIP_SERVICE_FAIL,
  DELETE_INTERNSHIP_SERVICE,
  DELETE_INTERNSHIP_SERVICE_SUCCESS,
  DELETE_INTERNSHIP_SERVICE_FAIL,
  
} from "./actionTypes";

export const getInternshipServices = () => ({
  type: GET_INTERNSHIP_SERVICES,
})

export const getInternshipServicesSuccess = internshipServices => ({
  type: GET_INTERNSHIP_SERVICES_SUCCESS,
  payload: internshipServices,
})

export const getInternshipServicesFail = error => ({
  type: GET_INTERNSHIP_SERVICES_FAIL,
  payload: error,
})

export const addNewInternshipService = internshipService => ({
  type: ADD_NEW_INTERNSHIP_SERVICE,
  payload: internshipService,
})

export const addInternshipServiceSuccess = internshipService => ({
  type: ADD_INTERNSHIP_SERVICE_SUCCESS,
  payload: internshipService,
})

export const addInternshipServiceFail = error => ({
  type: ADD_INTERNSHIP_SERVICE_FAIL,
  payload: error,
})

export const updateInternshipService = internshipService => ({
  type: UPDATE_INTERNSHIP_SERVICE,
  payload: internshipService,
})

export const updateInternshipServiceSuccess = internshipService => ({
  type: UPDATE_INTERNSHIP_SERVICE_SUCCESS,
  payload: internshipService,
})

export const updateInternshipServiceFail = error => ({
  type: UPDATE_INTERNSHIP_SERVICE_FAIL,
  payload: error,
})

export const deleteInternshipService = data => ({
  type: DELETE_INTERNSHIP_SERVICE,
  payload: data,
})

export const deleteInternshipServiceSuccess = data => ({
  type: DELETE_INTERNSHIP_SERVICE_SUCCESS,
  payload: data,
})

export const deleteInternshipServiceFail = error => ({
  type: DELETE_INTERNSHIP_SERVICE_FAIL,
  payload: error,
})

